import { useState, useEffect, useRef } from "react";
import { useIdeasNodeStore } from "../stores/ideaNodesStore";
import Markdown from "react-markdown";
import { CustomMarkdownRenderer } from "./CustomMarkdownRenderer";
import { Spin } from "antd";
import { css } from "@emotion/react";

const userMessageStyle = css`
  background-color: #2e2e2e;
  border-radius: 8px;
  padding: 12px;
  margin: 12px 0;
  display: flex;
  align-items: center;

  p {
    margin: 0;
  }
`;

export const ChatPane = () => {
  const chatPaneOpen = useIdeasNodeStore((state) => state.chatPaneOpen);
  const setChatPaneOpen = useIdeasNodeStore((state) => state.setChatPaneOpen);
  const chatPaneNodes = useIdeasNodeStore((state) => state.chatPaneNodes);
  const chatPaneLoading = useIdeasNodeStore((state) => state.chatPaneLoading);

  // Ref to the most recent user message so we can scroll it into view
  const lastUserMessageRef = useRef<HTMLDivElement | null>(null);

  // Compute the id of the last user-authored message
  const lastUserNodeId = (() => {
    for (let i = chatPaneNodes.length - 1; i >= 0; i--) {
      if (chatPaneNodes[i].speaker === "user") {
        return chatPaneNodes[i].id;
      }
    }
    return null;
  })();

  // When a new user message is appended or the pane is opened, scroll it to the top
  useEffect(() => {
    const last = chatPaneNodes[chatPaneNodes.length - 1];
    if (last?.speaker === "user" && lastUserMessageRef.current) {
      // Wait a frame to ensure DOM updates are committed before scrolling
      requestAnimationFrame(() => {
        lastUserMessageRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start",
        });
      });
    }
  }, [chatPaneNodes.length, chatPaneOpen, lastUserNodeId]);
  return (
    <div>
      {chatPaneNodes.map((chatNode) => {
        return (
          <div
            key={chatNode.id}
            ref={
              chatNode.id === lastUserNodeId ? lastUserMessageRef : undefined
            }
            css={chatNode.speaker === "user" ? userMessageStyle : undefined}
          >
            <CustomMarkdownRenderer rawMarkdownContent={chatNode.text} />

            {/* Associated content rending: */}
            {/* {chatNode.associated_content_text &&
            chatNode.associated_content_text.length ? (
              <div>
                Associated content:
                <Markdown>{chatNode.associated_content_text}</Markdown>
              </div>
            ) : (
              <></>
            )} */}
          </div>
        );
      })}

      {chatPaneLoading ? <Spin size="large" /> : <></>}
    </div>
  );
};
